import { render, staticRenderFns } from "./MaterialsManagement.vue?vue&type=template&id=540f8918&scoped=true"
import script from "./MaterialsManagement.vue?vue&type=script&lang=js"
export * from "./MaterialsManagement.vue?vue&type=script&lang=js"
import style0 from "./MaterialsManagement.vue?vue&type=style&index=0&id=540f8918&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f8918",
  null
  
)

export default component.exports